import { render, staticRenderFns } from "./finalreport.vue?vue&type=template&id=2b6a3ece&"
import script from "./finalreport.vue?vue&type=script&lang=js&"
export * from "./finalreport.vue?vue&type=script&lang=js&"
import style0 from "./finalreport.vue?vue&type=style&index=0&id=2b6a3ece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports